<template>
  <h1 :class="['anim__title']" ref="anim_title" :style="{ color: color }">
    <span class="anim__title-word" v-for="(word, wordIndex) in wordArray" :key="wordIndex">
      <span
        :class="['anim__title-char', { '-slow': slow }]"
        v-for="(letter, index) in word"
        :key="index"
        :style="[{ '--char-index': getCharIndex(wordIndex, index) }]"
      >
        {{ letter }}
      </span>
      <span v-if="wordIndex !== wordArray.length - 1"></span>
    </span>
  </h1>
</template>

<script>
export default {
  name: 'AnimatedTitle',
  data() {
    return {
      wordArray: [],
    }
  },
  props: {
    color: {
      type: String,
      default: null,
    },
    content: {
      type: Object,
      required: true,
    },
    slow: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 400,
    },
  },
  methods: {
    getCharIndex(wordIndex, letterIndex) {
      let charIndex = 0
      for (let i = 0; i < wordIndex; i++) {
        charIndex += this.wordArray[i].length
      }
      charIndex += letterIndex
      return charIndex
    },
  },
  mounted() {
    const title = this.$refs.anim_title

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        setTimeout(() => {
          entry.target.classList.add('--active')
        }, this.delay)
      })
    })
    observer.observe(title)
  },
  watch: {
    content: {
      deep: true,
      handler(newVal) {
        this.wordArray = newVal.title.split(' ')
      },
      immediate: true,
    },
  },
}
</script>
